<template>
    <div class="public_container m_message_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true"> </ReturnNavBar>
        </div>
        <ul class="m_message_tab">
            <li
                v-for="item in tabList"
                :key="item.state"
                :class="{ active: item.state == tabActive }"
                @click="handleClickTab(item)"
            >
                <i :class="['iconfont', item.state == tabActive ? item.activeIcon : item.icon]"></i>
                <span>{{ item.name }}</span>
            </li>
        </ul>
        <div class="mobile_container">
            <template v-if="tabActive == 'setting'">
                <div class="message_list_content">
                    <ul>
                        <li
                            v-for="item in categoryList"
                            :key="item.type"
                            class="message_list_item"
                            @click="handleClickCategoryDetail(item)"
                        >
                            <div class="message_list_item_icon">
                                <img :src="item.icon_url" alt="" />
                            </div>
                            <p class="message_list_item_content">{{ item.name }}</p>
                            <div class="message_list_item_arrow">
                                <van-icon name="arrow" />
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
            <template v-else>
                <div class="message_list_content2">
                    <div class="item_set_box">
                        <div>
                            <p class="title">设置消息免打扰时段</p>
                            <p>关闭后，消息提醒为实时通知，开启后，在免打扰时间段内，微信通知不再提醒</p>
                        </div>
                        <van-switch
                            v-model="notDisturbForm.enabled"
                            active-color="#2990FF"
                            inactive-color="#999999"
                            size="20px"
                            @change="handleChangeTime"
                        />
                    </div>
                    <ul class="list_select_box" v-show="notDisturbForm.enabled">
                        <li @click="handleClickSelectTime('start_time')">
                            <span>每天</span>
                            <div class="list_item_time">
                                <span>{{ notDisturbForm.start_time }}</span>
                                <van-icon name="arrow-down" />
                            </div>
                        </li>
                        <li @click="handleClickSelectTime('end_time')">
                            <span>至</span>
                            <div class="list_item_time">
                                <span v-if="notDisturbForm.end_type && notDisturbForm.end_time">{{
                                    notDisturbForm.end_type == 1 ? "当日" : "次日"
                                }}</span>
                                <span>{{ notDisturbForm.end_time }}</span>
                                <van-icon name="arrow-down" />
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
        </div>
        <van-popup v-model="settingPopupVisible" position="right" :style="{ width: '100%', height: '100%' }">
            <div class="setting_popup_wrap" v-loading="templateListLoading">
                <div class="returnNavBar">
                    <div class="returnNavBarLeft">
                        <van-icon @click="handleClickPopupClose" name="arrow-left" />
                        <span v-text="'返回'" class="normal_title"></span>
                    </div>
                </div>
                <div class="setting_popup_content">
                    <p class="message_right_title">关闭后，将不再收到此类消息提醒，可在消息免打扰中查看</p>
                    <ul>
                        <li v-for="item in templateList" :key="item.template_id">
                            <span>{{ item.template_name }}</span>
                            <van-switch
                                v-model="item.is_closed"
                                active-color="#2990FF"
                                inactive-color="#999999"
                                :active-value="false"
                                :inactive-value="true"
                                :disabled="item.can_disturb === false ? true : false"
                                size="20px"
                                @change="handleSwitchChange(item)"
                            />
                        </li>
                    </ul>
                </div>
            </div>
        </van-popup>
        <!--单选弹窗-->
        <van-overlay
            :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
            v-if="showRadioPicker"
            :show="showRadioPicker"
        >
            <div class="radio_option_wrap">
                <p class="title">选择时间</p>
                <ul class="radio_option_list">
                    <li v-for="item in endDateTypeList" class="radio_option_item" @click="handleClickRadioOption(item)">
                        <span v-text="item.label"></span>
                        <van-icon name="arrow" />
                    </li>
                </ul>
            </div>
        </van-overlay>
        <!-- 选择时间 -->
        <van-overlay :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }" v-if="showTimePicker" :show="showTimePicker">
            <div class="radio_option_wrap">
                <van-datetime-picker v-model="dateTime" type="time" title="选择时间" :min-hour="0" :max-hour="23">
                    <div slots="title" class="title">
                        <span class="van-icon_box" @click="handleClickTimePickerClose"
                            ><van-icon name="arrow-left"
                        /></span>
                        <span>选择时间</span>
                    </div>
                </van-datetime-picker>
                <van-button type="info" @click="handleClickTimeConfirm">确认</van-button>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import {
    MessageCategoryList,
    MessageTemplateList,
    MessageSettingSwitch,
    MessageSettingDistrubPeriod,
    GetDistrubPeriod,
} from "@/api";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "MessageAdminManagement",
    components: { ReturnNavBar },
    data() {
        return {
            loading: false,
            tabActive: "setting",
            tabList: [
                {
                    state: "setting",
                    name: "消息设置",
                    icon: "icon-xiaoxishezhi",
                    activeIcon: "icon-xiaoxishezhi-xuanzhong",
                },
                {
                    state: "resolveSetting",
                    name: "消息接收设置",
                    icon: "icon-xiaoxijieshoushezhi",
                    activeIcon: "icon-xiaoxijieshoushezhi-xuanzhong",
                },
            ],
            category_id: "",
            categoryList: [],
            settingPopupVisible: false,
            templateListLoading: false,
            templateList: [],
            notDisturbForm: {
                enabled: false,
                start_time: "23:00",
                end_type: 2,
                end_time: "08:00",
            },
            endDateTypeList: [
                { label: "当日", value: 1 },
                { label: "次日", value: 2 },
            ],
            currentOperateType: "", // 当前操作的时间类型 start_time:开始，end_time:结束
            showRadioPicker: false,
            showTimePicker: false,
            dateTime: "",
            orderIcon: "https://download.hecoos.com/enlightv/2024-49/a5aef7a899d3dc38199018c3339ab005.png",
            personnelIcon: "https://download.hecoos.com/enlightv/2024-49/c7d7b988cc4553663e533998f1a190fb.png",
            productIcon: "https://download.hecoos.com/enlightv/2024-49/2352388744b54470c15be9c8fec9f301.png",
            logIcon: "https://download.hecoos.com/enlightv/2024-49/8e3d4e047b8ad0672302811d12f332ef.png",
            approvalIcon: "https://download.hecoos.com/enlightv/2024-49/ba6aea1e12afc36610a6dff96e1eae92.png",
            customerIcon: "https://download.hecoos.com/enlightv/2024-49/3b889816afbb59992421607adcfadc18.png",
            workIcon: "https://download.hecoos.com/enlightv/2024-49/44a5c31125d52cbc8170a73f4a4d5b77.png",
            financeIcon: "https://download.hecoos.com/enlightv/2024-49/b74b39b1a6f1b2bce44214df70158abd.png",
        };
    },
    created() {
        this.getMessageCategoryList();
    },
    methods: {
        handleClickTab({ state }) {
            this.tabActive = state;
            if (this.tabActive == "resolveSetting") {
                this.getDistrubPeriod();
            }
        },
        getItemIcon(type) {
            let icon = this[`${type}Icon`];
            return icon;
        },
        // 获取消息分类列表
        getMessageCategoryList() {
            this.loading = true;
            MessageCategoryList()
                .then((res) => {
                    if (res.code === 200) {
                        this.categoryList = res.data || [];
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 消息设置
        handleClickCategoryDetail({ id }) {
            this.category_id = id;
            this.settingPopupVisible = true;
            this.templateListLoading = true;
            MessageTemplateList({ category_id: this.category_id })
                .then((res) => {
                    if (res.code === 200) {
                        // 数据结构
                        // can_disturb: 是否可以设置免打扰
                        // is_closed: 模版可以设置免打扰， 并且用户设置关闭了，就返回true为关闭，否则未开启。如果可以设置，就可以走开启免打扰
                        this.templateList = res.data || [];
                    }
                    this.templateListLoading = false;
                })
                .catch(() => {
                    this.templateListLoading = false;
                });
        },
        // 消息设置关闭
        handleClickPopupClose() {
            this.settingPopupVisible = false;
        },
        // 模版开启关闭
        handleSwitchChange(item) {
            const params = {
                template_id: item.template_id,
                status: item.is_closed, //是否开启免打扰 开启true 关闭false
            };
            MessageSettingSwitch(params).then((res) => {
                if (res.code === 200) {
                    this.$toast("设置成功");
                }
            });
        },
        // 获取免打扰时间段
        getDistrubPeriod() {
            this.loading = true;
            GetDistrubPeriod()
                .then((res) => {
                    if (res.code == 200) {
                        this.notDisturbForm.enabled = res.data.enabled;
                        if (res.data && res.data.start_time) {
                            this.notDisturbForm.start_time = res.data.start_time;
                        }
                        if (res.data && res.data.end_type) {
                            this.notDisturbForm.end_type = res.data.end_type;
                        }
                        if (res.data && res.data.end_time) {
                            this.notDisturbForm.end_time = res.data.end_time;
                        }
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 日期类型选择
        handleClickSelectTime(type) {
            this.currentOperateType = type;
            if (type == "start_time") {
                this.dateTime = this.notDisturbForm.start_time;
                this.showTimePicker = true;
            } else {
                this.dateTime = this.notDisturbForm.end_time;
                this.showRadioPicker = true;
            }
        },
        handleClickRadioOption(item) {
            this.notDisturbForm.end_type = item.value;
            this.showTimePicker = true;
        },
        // 时间选择
        handleClickTimePickerClose() {
            this.showTimePicker = false;
        },
        // 时间选择确认
        handleClickTimeConfirm() {
            this.showTimePicker = false;
            if (this.currentOperateType == "start_time") {
                this.notDisturbForm.start_time = this.dateTime;
            } else {
                this.notDisturbForm.end_time = this.dateTime;
                this.showRadioPicker = false;
            }
            this.$nextTick(() => {
                this.handleChangeTime();
            });
        },
        // 免打扰时间段设置
        handleChangeTime() {
            let params = {};
            if (this.notDisturbForm.enabled && this.notDisturbForm.end_type == 1) {
                if (this.notDisturbForm.end_time < this.notDisturbForm.start_time) {
                    this.$toast("结束时间不能小于开始时间");
                    return false;
                }
            }
            if (this.notDisturbForm.enabled && (!this.notDisturbForm.start_time || !this.notDisturbForm.end_time)) {
                return false;
            }
            if (this.notDisturbForm.enabled) {
                params = {
                    enabled: this.notDisturbForm.enabled,
                    start_time: this.notDisturbForm.start_time ? this.notDisturbForm.start_time : "",
                    end_type: this.notDisturbForm.end_type,
                    end_time: this.notDisturbForm.end_time ? this.notDisturbForm.end_time : "",
                };
            } else {
                params = {
                    enabled: this.notDisturbForm.enabled,
                    start_time: "",
                    end_type: "",
                    end_time: "",
                };
            }
            MessageSettingDistrubPeriod(params).then((res) => {
                if (res.code === 200) {
                    this.$toast("设置成功");
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.m_message_wrap {
    background-color: #ffffff;
    .m_message_tab {
        padding: 0 16px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        li {
            width: 156px;
            height: 40px;
            text-align: center;
            line-height: 40px;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(102, 102, 102, 1);
            border-radius: 20px;
            .iconfont {
                font-size: 14px;
                margin-right: 4px;
            }
            &:active,
            &.active {
                background: rgba(41, 144, 255, 0.05);
                font-size: 16px;
                font-weight: 700;
                color: rgba(41, 144, 255, 1);
            }
        }
    }
    .mobile_container {
        background-color: #ffffff;
    }
    .message_list_content {
        width: 100%;
        height: calc(100%);
        padding: 8px 0;
        overflow-y: auto;
        .message_list_item {
            padding: 8px 16px;
            border-radius: 4px;
            display: flex;
            align-items: center;
            gap: 8px;
            margin-bottom: 4px;
            cursor: pointer;

            .message_list_item_icon {
                width: 42px;
                height: 42px;
                position: relative;
                flex-shrink: 0;

                img {
                    width: 42px;
                    height: 42px;
                }
            }

            .message_list_item_content {
                flex: 1;
                overflow: hidden;
                font-size: 14px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
            }
            .message_list_item_arrow {
                flex-shrink: 0;
                .van-icon {
                    color: rgba(153, 153, 153, 1);
                }
            }

            &.active {
                background-color: rgba(0, 0, 0, 0.02);
            }
        }
    }
    .message_list_content2 {
        padding: 16px;
        .item_set_box {
            min-height: 72px;
            padding: 12px 10px 12px 16px;
            border-radius: 8px;
            border: 1px solid rgba(153, 153, 153, 0.1);
            display: flex;
            align-items: center;
            justify-content: space-between;
            gap: 10px;
            p {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(153, 153, 153, 1);
            }
            .title {
                font-size: 16px;
                font-weight: 700;
                letter-spacing: 0px;
                line-height: 24px;
                color: rgba(51, 51, 51, 1);
                margin-bottom: 2px;
            }
            .van-switch {
                flex-shrink: 0;
            }
            ::v-deep {
                .van-switch__node {
                    width: 18px;
                    height: 18px;
                    top: 1px;
                    left: 1px;
                }
            }
        }
        ul {
            margin-top: 20px;
            border-radius: 8px;
            border: 1px solid rgba(153, 153, 153, 0.1);
            li {
                height: 50px;
                padding: 0 8px 0 16px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                span {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
                .list_item_time {
                    display: flex;
                    align-items: center;
                    gap: 4px;
                    .van-icon {
                        color: rgba(153, 153, 153, 1);
                    }
                }
                & + li {
                    border-top: 1px solid rgba(153, 153, 153, 0.1);
                }
            }
        }
    }
}
.setting_popup_wrap {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    .setting_popup_content {
        flex: 1;
        overflow-y: auto;
        padding: 0 16px;
        .message_right_title {
            padding: 10px 0;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 18px;
            color: rgba(153, 153, 153, 1);
        }
        ul {
            li {
                min-height: 54px;
                border-radius: 6px;

                border: 1px solid rgba(153, 153, 153, 0.1);
                padding: 16px 10px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 8px;
                & > span {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(51, 51, 51, 1);
                }
                ::v-deep {
                    .van-switch--disabled {
                        background-color: rgba(182, 217, 255, 1) !important;
                    }
                    .van-switch__node {
                        width: 18px;
                        height: 18px;
                        top: 1px;
                        left: 1px;
                    }
                }
            }
        }
    }
}
.radio_option_wrap {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 356px;
    background-color: #ffffff;
    border-radius: 8px 8px 0px 0px;
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.08);
    padding: 0 16px;
    .title {
        font-size: 16px;
        font-weight: 700;
        letter-spacing: 0px;
        line-height: 48px;
        color: rgba(51, 51, 51, 1);
        text-align: center;
    }
    .radio_option_list {
        border-radius: 8px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(245, 245, 245, 1);
        .radio_option_item {
            background-color: #ffffff;
            padding: 10px 10px 10px 16px;
            font-size: 16px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 24px;
            color: rgba(51, 51, 51, 1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            & + .radio_option_item {
                border-top: 1px solid rgba(232, 232, 232, 1);
            }
            .van-icon {
                color: rgba(153, 153, 153, 1);
            }
        }
    }
    ::v-deep {
        .van-datetime-picker {
            .van-picker__toolbar {
                height: 48px;
                .title {
                    width: 100%;
                    position: relative;
                    font-size: 16px;
                    font-weight: 700;
                    letter-spacing: 0px;
                    line-height: 48px;
                    color: rgba(51, 51, 51, 1);
                    text-align: center;
                    .van-icon_box {
                        position: absolute;
                        left: 0;
                        top: 12px;
                        width: 24px;
                        height: 24px;
                        text-align: center;
                        line-height: 24px;
                    }
                    .van-icon {
                        color: rgba(102, 102, 102, 1);
                        font-weight: bold;
                    }
                }
            }
        }
    }
    .van-button {
        width: 100%;
        height: 38px;
        border-radius: 8px;
        background: rgba(41, 144, 255, 1);
    }
}
</style>
